import { render, staticRenderFns } from "./ClusterAdd.vue?vue&type=template&id=71189596&scoped=true&"
import script from "./ClusterAdd.vue?vue&type=script&lang=js&"
export * from "./ClusterAdd.vue?vue&type=script&lang=js&"
import style0 from "./ClusterAdd.vue?vue&type=style&index=0&id=71189596&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71189596",
  null
  
)

export default component.exports